export const cookie = (function() {
  function encode(s) {
    return encodeURIComponent(s);
  }

  function decode(s) {
    return decodeURIComponent(s);
  }

  function stringifyCookieValue(value) {
    return encode(JSON.stringify(value));
  }

  return {
    write: function(key, value, options) {
      options || (options = {});
      if (typeof options.expires === 'number') {
        var days = options.expires,
          t = (options.expires = new Date());
        t.setTime(+t + days * 864e5);
      }
      return (document.cookie = [
        encode(key),
        '=',
        stringifyCookieValue(value),
        options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
        options.path ? '; path=' + options.path : '',
        options.domain ? '; domain=' + options.domain : '',
        options.secure ? '; secure' : ''
      ].join(''));
    },
    read: function(key) {
      var result = undefined;
      var cookies = document.cookie ? document.cookie.split('; ') : [];
      for (var i = 0, l = cookies.length; i < l; i++) {
        var parts = cookies[i].split('=');
        var name = decode(parts.shift());
        var value = parts.join('=');
        if (key && key === name) {
          // If second argument (value) is a function it's a converter...
          result = value;
          break;
        }
      }
      return result;
    }
  };
})();

export const localStorage = (function() {
  return {
    isSupport: (function() {
      var test = 'test';
      try {
        window.localStorage.setItem(test, test);
        window.localStorage.removeItem(test);
        return true;
      } catch (e) {
        return false;
      }
    })(),
    read: function(key) {
      var value = null;
      if (this.isSupport) {
        value = window.localStorage.getItem(key);
      }
      return value;
    },
    write: function(key, value) {
      if (this.isSupport) {
        window.localStorage.setItem(key, value);
      }
      return true;
    }
  };
})();

export function store(key, value, domain, minutesToExpire) {
  var date = new Date();
  date.setTime(date.getTime() + minutesToExpire * 60 * 1000);

  cookie.write(key, value, { path: '/', domain: domain, expires: date });
  localStorage.write(key, JSON.stringify(value));
}

export function read(key) {
  var value = cookie.read(key);
  if (!value) {
    value = localStorage.read(key);
  }
  return value;
}
